import { FC } from 'react';

import { AccountSettings } from '@shared/components/AccountSettings';
import StatPageSideBar from '@shared/components/StatPageSideBar';

/**
 * 상조관리자 내 계정 페이지.
 * 내용은 다른 콘솔과 같은 공용 AccountSettings를 그대로 쓰고,
 * 좌측 사이드바를 유지해 콘솔 안에서 오갈 수 있게 한다.
 */
const AgencyAdminSettingsPage: FC = function AgencyAdminSettingsPage() {
  return (
    <div className="flex">
      <div className="flex flex-col">
        <StatPageSideBar />
      </div>
      <div className="mx-auto max-w-screen-2xl flex-1">
        <AccountSettings heading="계정정보" />
      </div>
    </div>
  );
};

export default AgencyAdminSettingsPage;
